<mat-accordion>
  <mat-expansion-panel [(expanded)]="expanded" class="config-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>"No data" label configuration</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <div class="wrap">
        <mat-checkbox formControlName="show" class="item">Show</mat-checkbox>
        @if (form.get('show').value) {
          <mat-checkbox formControlName="withRedictToLabConnections" class="item">Redirect to Lab Connections page?</mat-checkbox>
        }
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>